import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore";
import "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyCXcfsNDjbPdTwVnSduf41vxYKo5uCIwIM",
    authDomain: "sgdic-f6ed1.firebaseapp.com",
    projectId: "sgdic-f6ed1",
    storageBucket: "sgdic-f6ed1.appspot.com",
    messagingSenderId: "172992217922",
    appId: "1:172992217922:web:1e6cde40a79732c780fedb"
};
  
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export const db = getFirestore(app);

export default getFirestore(app);
